import { Fira_Code, Inter, JetBrains_Mono } from 'next/font/google';
import { cn } from '@/utils/shad';

export const firaCode = Fira_Code({
  subsets: ['latin'],
  display: 'swap',
});

export const inter = Inter({
  subsets: ['latin'],
  display: 'swap',
});

export const jetbrainsMono = JetBrains_Mono({
  subsets: ['latin'],
  display: 'swap',
});

/** Canvas / Chart.js `font.family` (axes/tooltips use defaults unless overridden separately). */
export const jetbrainsMonoChartFontFamily = jetbrainsMono.style.fontFamily;

export const liveActivityCountLineClassName = cn(jetbrainsMono.className, 'text-[12px] font-medium');
